module.exports = "<div class=\"ui-select-no-choice dropdown\"\n    ng-show=\"$select.items.length == 0\">\n    <div class=\"dropdown-content\">\n        <div data-selectable=\"\" ng-transclude></div>\n     </div>\n </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/third/ui-select/src/select2/no-choice.tpl.html
// module id = 467
// module chunks = 0